module.exports = __webpack_public_path__ + "static/map-01ae53caad7e9930c72205eddba707d3.png";